import React, { useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { ProgressCircle, RCWidth, base, deepClone, isValidURL_adv } from '../utils'
import Loading from './Loading'
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import { useDispatch, useSelector } from 'react-redux';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { redNex } from '../Redux/nexSlice';


function SpeedTest({ nexListn, _nex }) {
    const [data, setData] = useState([])
    const [url, setUrl] = useState('')
    const [device, setDevice] = useState('')
    const [device0, setDevice0] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [noInput1, setNoInput1] = useState(false)
    const [noInput2, setNoInput2] = useState(false)

    const user = useSelector(state=> state.user.user)
    const nx = useSelector(state=> state.nex.nex)

    const dispatch = useDispatch()

    const getData = async () => {
        if(url !== '' && device !== '') {
          if(!isValidURL_adv(url)) {
            setNoInput1(true)
            return
          }
          setNoInput1(false)
          setNoInput2(false)

          const updateAnalytics = async () => {
            const tool = window.location.pathname.split('/').pop();
            let tools = deepClone(user.analytics.toolsUsage);
        
            if (isNaN(tools[tool]) || tools[tool] == 'NaN') {
                tools[tool] = 1;
            } else {
                tools[tool] = Number(tools[tool]) + 1;
            }
        
            await updateDoc(doc(db, 'users', user.id), { analytics: { toolsUsage: tools } });
        };


            setIsLoading(true)
            fetch(`${base}/res`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                type: 'st',
                url: url,
                device: device,
                userId: user.id
              })
            }).then(res=> res.json()).then(data=> {
              setData(data)
              setDevice0(device)
              setIsLoading(false)
              dispatch(redNex(nx))
              updateAnalytics()
            })
          } else {
            if(url.trim() == '') setNoInput1(true)
            if(device == '') setNoInput2(true)
          }
    }


    function renderObject(obj) {
        return (
          <div>
            <h3 style={{marginLeft: '10px', marginBottom: '10px'}}>Audits and Recommendations</h3>
            {Object.entries(obj).map(([key, value]) => (
              <div key={key} style={{marginBottom: '17px', marginInline: '10px', display: 'flex', flexDirection: 'column'}}>
                <span style={{textTransform: 'capitalize', marginRight: '12px', fontWeight: '400'}}>{value.id.replaceAll('-', ' ')}: </span>
                <span>{value.description}</span>
                <span style={{color: 'gray'}}>{value.displayValue}</span>
                <span style={{color: 'darkcyan'}}>Score:  {value.score * 100}%</span>
              </div>
            ))}
          </div>
        );
      }





  return (
    <SpeedTestContainer>
        <SpeedTestInputContainer>
        <h2>Speed Test <span style={{fontSize: 'medium'}}></span></h2>
            <SpeedTestInputInnerContainer>
                <div style={{position: 'relative', marginBottom: '50px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '23px', top: '20%', fontSize: 'small'}}>Your Website or Webpage</label><input type='url' placeholder='example.com' style={{marginLeft: '20px', color: '#1eb277', borderColor: noInput1? 'red': ''}} value={url} onChange={e=> setUrl(e.target.value)}/></div>

                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '300px', marginLeft: '30px'}}>
                    <h4 style={{fontWeight: '300', marginBottom: '10px'}}>Select device to test page speed on:</h4>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '300px', gap: '70px'}}>
                    <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                        {!noInput2 && <DesktopWindowsIcon style={{fontSize: '50px', color: device=== 'desktop'? 'var(--tst-color)': ''}}/>}
                        {noInput2 && <DesktopWindowsIcon style={{fontSize: '50px', color: 'red'}}/>}
                <label>
                    <input
                    type="radio"
                    value="desktop"
                    checked={device === 'desktop'}
                    onChange={e=> setDevice(e.target.value)}
                    style={{marginInline: '10px'}}
                    disabled={isLoading}
                    />
                    Desktop
                </label>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                {!noInput2 && <SmartphoneIcon style={{fontSize: '50px', color: device=== 'mobile'? 'var(--tst-color)': ''}}/>}
                {noInput2 && <SmartphoneIcon style={{fontSize: '50px', color: 'red'}}/>}
                <label>
                    <input
                    type="radio"
                    value="mobile"
                    checked={device === 'mobile'}
                    onChange={e=> setDevice(e.target.value)}
                    style={{marginInline: '10px'}}
                    disabled={isLoading}
                    />
                    Mobile
                </label>
                </div>
                </div>
                </div>
                {nx !== 0 && <button onClick={()=> !isLoading? getData() : ()=> {}} style={isLoading ? {backgroundColor: 'lightgray', color: 'gray', cursor: 'not-allowed'}: {}}>{!isLoading ?'Run Test': 'Running Test ...'}</button>}
                {nx === 0 && <button style={{backgroundColor: 'lightgray', color: 'red', cursor: 'not-allowed'}}>Insufficient Nexilum units!</button>}
            </SpeedTestInputInnerContainer>
        </SpeedTestInputContainer>

        {data.length !== 0 && !isLoading && <SpeedTestResContainer>
            <TestRes style={{border: 'none', justifyContent: 'space-around'}}>
                <TestResLeftSection device={device0}>
                    <div>
                    <img src={data[0].lighthouseResult.fullPageScreenshot.screenshot.data}/>
                    </div>
                </TestResLeftSection>
                <TestResRightSection>
                    <ProgressCircle percentage={(data[0].lighthouseResult.categories.performance.score * 100).toFixed(0)} />
                    Performance: {(data[0].lighthouseResult.categories.performance.score * 100).toFixed(0)}%
                    <p style={{marginTop: '20px'}}>Total load time:  <span style={{color: parseInt((data[0].lighthouseResult.audits['speed-index']?.displayValue).toString().split('.')[0]) <= 3? 'green': 'red'}}>{data[0].lighthouseResult.audits['speed-index']?.displayValue}</span></p>
                </TestResRightSection>
            </TestRes>

            <TestRes style={{display: 'flex', flexDirection: 'column'}}>
                <div className='performance_res'>
                    <p><span className='span__title'>First Contentful Paint</span> <span>{data[0].loadingExperience.metrics?.FIRST_CONTENTFUL_PAINT_MS.category || '-'}</span><p></p></p>
                    <p className='performance_desc'></p>
                    <p><span className='span__title'>First Input Delay</span> <span>{data[0].loadingExperience.metrics?.FIRST_INPUT_DELAY_MS.category || '-'}</span></p>
                    <p className='performance_desc'></p>
                    <p><span className='span__title'>First Contentful Paint</span> <span>{data[0].lighthouseResult.audits['first-contentful-paint']?.displayValue || '-'}</span></p>
                    <p className='performance_desc'>{data[0].lighthouseResult?.audits['first-contentful-paint']?.description}</p>
                    <p><span className='span__title'>Speed Index</span> <span>{data[0].lighthouseResult.audits['speed-index']?.displayValue || '-'}</span></p>
                    <p className='performance_desc'>{data[0].lighthouseResult.audits['speed-index']?.description}</p>
                    <p><span className='span__title'>Time To Interactive</span> <span>{data[0].lighthouseResult.audits['interactive']?.displayValue || '-'}</span></p>
                    <p className='performance_desc'>{data[0].lighthouseResult.audits['interactive']?.description}</p>
                    <p><span className='span__title'>First Meaningful Paint</span> <span>{data[0].lighthouseResult.audits['first-meaningful-paint']?.displayValue || '-'}</span></p>
                    <p className='performance_desc'>{data[0].lighthouseResult.audits['first-meaningful-paint']?.description}</p>
                    <p><span className='span__title'>First CPU Idle</span> <span>{data[0].lighthouseResult.audits['first-cpu-idle']?.displayValue || '-'}</span></p>
                    <p className='performance_desc'>{data[0].lighthouseResult.audits['first-cpu-idle']?.description}</p>
                    <p><span className='span__title'>Estimated Input Latency</span> <span>{data[0].lighthouseResult.audits['estimated-input-latency']?.displayValue || '-'}</span></p>
                    <p className='performance_desc'>{data[0].lighthouseResult.audits['estimated-input-latency']?.description}</p>
                </div>
                <div style={{marginTop: '30px'}}>
                    {renderObject(data[0].lighthouseResult.audits, data[0].lighthouseResult.timing.total)}
                </div>
            </TestRes>


        </SpeedTestResContainer>}
        {isLoading && <Loading />}
        {isLoading && <p style={{color: 'white', width: '100%', textAlign: 'center', marginTop: '20px'}}>This may take some time as we conduct a thorough test</p>}

        {data.length == 0 && !isLoading && <Intro>

          <h3>Tool Overview</h3>
          <br />
          <p>
            The Speed Test Tool measures the loading speed of your web pages on both desktop and mobile devices. 
            By identifying load times and performance bottlenecks, you can optimize your site to ensure fast and efficient user experiences.
          </p>
          <br /><br />
          
          <h3>Instructions</h3>
          <br />
          <p>1. Enter the URL of the page you want to test</p>
          <p>2. Select whether to test the load speed on desktop or mobile device</p>
          <p>3. Click "Run Test" to start the speed analysis</p>
          <br /><br />
          
          <h3>Tips</h3>
          <br />
          <p>Regularly test your page speed and address performance issues to improve user experience and search engine rankings</p>

        </Intro>}
    </SpeedTestContainer>
  )
}

export default SpeedTest


const SpeedTestContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${RCWidth};
`


const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`


const SpeedTestInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 2px 2px 16px -8px rgb(239, 239, 239);
  background-color: white;
  margin-inline: 20px;
  padding: 20px;
  margin-top: 25px;
  z-index: 2;

  > h2 {
    font-weight: 100;
    margin-bottom: 20px;
  }

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--tst-color);
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }

  > div > .select-device {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: var(--tst-color);
  }

  > div > button {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: var(--tst-color);
    color: white;
  }

  > div > button:hover {
    color: var(--tst-color);
    background-color: rgb(239, 239, 239);
  }
`


const SpeedTestInputInnerContainer = styled.div`
  display: flex;
  margin-top: 20px;

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--tst-color);
    padding-left: 100px;
    font-size: medium;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }
`

const SpeedTestResContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: scroll;
  background-color: white;
  border-radius: 2px;
  z-index: 2;
  margin-bottom: 70px;
  padding-bottom: 10px;
`


const TestRes = styled.div`
    display: flex;
    flex-direction: row;
    margin-block: 5px;


    .performance_res {
        margin-inline: 10px;
        width: 500px;

        > p {
            font-weight: 300;
            display: flex;
            flex-direction: row;
        }

        > p > span {
            margin-left: 10px;
        }

        > p > .span__title {
            font-weight: 300;
            width: 200px;
        }

        > .performance_desc {
            margin: 6px 0 25px 10px;
            font-size: small;
            color: gray;
            width: 800px;
        }
    }
`


const TestResLeftSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    margin: 10px;
    border-right: 1px solid rgb(230, 230, 230);
    flex: 0.4;


    > div {
        /* width: 200px; */
        width: ${props=> props.device === 'mobile'? '200px': '500px'};
        /* height: 400px; */
        height: ${props=> props.device === 'mobile'? '330px': '320px'};
        border-radius: ${props=> props.device === 'mobile'? '3px': '5px'};
        overflow: hidden;
    }


    > div > img {
        object-fit: cover;
        width: 100%;
        height: 100%;
        object-position: top;
    }
`


const TestResRightSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    margin: 10px;
    flex: 0.6;
    height: 300px;
`



const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h3 {
    color: white;
    font-family: 'Quicksand';
    font-weight: 500;
  }

  > p {
    color: white;
    font-family: 'Quicksand';
    width: 60%;
  }
`